import { AnimatePresence, motion } from 'framer-motion';

import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import { Advt } from './components/Advt/Advt';
import Message from './components/Message/Message';

import posterDefault from './assets/images/bgPoster.png';
import bgDefaultVideo from './assets/video/bgVideo.webm';
import { Winners } from './components/Winners/Winners';

function App() {
  const { isVisible, currentState, currentMessage, winnerMessages } =
    useBroadcast();
  const { speedSlow, bgVideo, bgPoster } = useGetParams();

  return (
    <div
      className="app-wrapper"
      style={{
        '--speed': `${speedSlow || 2000}ms`,
        '--speedExit': `${(speedSlow || 2000) / 1.5}ms`,
      }}
    >
      <div className="messagesWrapper">
        <AnimatePresence mode="wait">
          {currentState === 'S2' && currentMessage && (
            <motion.div
              key="message-s2"
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Message
                message={currentMessage?.message}
                rotateSign={currentMessage?.rotateSign}
                speedSlow={speedSlow}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <AnimatePresence mode="wait">
        {['S1', 'S2'].includes(currentState) && (
          <motion.div
            key="advt"
            className="advtWrapper"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Advt currentState={currentState} />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {currentState === 'S3' && (
          <motion.div
            key={currentState}
            className="winnersBlock"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Winners winnerMessages={winnerMessages} />
          </motion.div>
        )}
      </AnimatePresence>

      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          id="bgVideo"
          poster={bgVideo === '1' ? posterDefault : bgPoster}
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
